import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from 'i18next';
import { useFormik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
    cellphoneCodes,
    homePhoneCodes,
} from "../../../utils/constants/cellphoneCodes";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
    Autocomplete,
    Checkbox,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    InputLabel,
    NativeSelect,
    TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import arrowleft from "../../../assets/images/arrow-left-black.svg";
import { GetCities } from "../../../services/GetCities";
import RegThirdStepValues from "../../../entities/RegThirdStepValues";
import RenderInputError from "../../Login/RenderInputError/RenderInputError";
import { GetMemberDetails } from "../../../services/GetMemberDetails";
import City from "../../../entities/City";
import {
    getCityLabel,
    getFormatDate,
    getGenderLabel,
    getMeritalStatusLabel,
    getDeliveryOptionLabel,
    getCellphoneNumber,
    getDeliveryOptionCode,
    getCityCode,
    getUserIdWithZeros,
} from "../../../utils/helpers/MemberDataHelper";
import { getSumOfDigits } from "../../../utils/helpers/formUtils";
import {
    UpdateMemberDetails,
    updateMemberDetailsUtil,
} from "../../../services/UpdateMemberDetails";
import { useDispatch, useSelector } from "react-redux";
import {
    setModalChild,
    setModalState,
} from "../../../state/actions/modalAction";
import HelpCircleIcon from "../../../components/HelpCircleIcon/HelpCircleIcon";
import RequestAcceptedPopup from "../../../components/RequestAcceptedPopup/RequestAcceptedPopup";
import CircleLoading from "../../../components/CircleLoading/CircleLoading";
import { useHistory } from "react-router-dom";
import { isEnterPress } from "../../../utils/helpers/accessibilityUtil";
import UserFund from "../../../entities/UserFund";
import { GetMemberFunds } from "../../../services/GetMemberFunds";
import { getUserFunds } from "../../../services/getUserFunds";
import ErrorPopup from "../../../components/ErrorPopup/ErrorPopup";
import RegThirdStepProps from "./RegThirdStepProps";

import "./RegThirdStep.scss";
import { yellow } from "@mui/material/colors";
import useInputFocus from "../../../customHooks/useInputFocus";
import { regExpAZ } from "../../../utils/helpers/regExpUtil";
import { el } from "date-fns/locale";

const InvalidCityCode = "99999";
const MissingCityCode = "99998";
const Nosettlementchosen = "-1";
const hebrewRegex = /^[אבגדהוזחטיכלמנסעפצקרשתףץםןך123456789" ']*$/;

const RegThirdStep = (props: RegThirdStepProps) => {
    const { t, i18n } = useTranslation("common");
    const dispatch = useDispatch();
    const history = useHistory();
    const userState = useSelector((state: any) => state.UserReducer);

    const deliveryOptions: string[] = [
        t("RegThirdStep.deliveryOption1"),
        t("RegThirdStep.deliveryOption2"),
        t("RegThirdStep.deliveryOption3"),
        t("RegThirdStep.deliveryOption4"),
        t("RegThirdStep.deliveryOption5"),
    ];

    const newDeliveryOptions: string[] = [
        t("RegThirdStep.deliveryOption2"),
        t("RegThirdStep.deliveryOption3"),
        t("RegThirdStep.deliveryOption4"),
    ];

    const [citiesList, setCitiesList] = useState([]);
    const [citiesFullList, setCitiesFullList] = useState([]);
    const [memberData, setMemberData] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(true);
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [updateError, setUpdateError] = useState<boolean>(false);
    const [updateErrorPhone, setupdateErrorPhone] = useState<boolean>(false);
    const [updateErrorEmail, setupdateErrorEmail] = useState<boolean>(false);
    const [clickbtnsub, setClickbtnsub] = useState<boolean>(false);


const validate = (values: RegThirdStepValues) => {

    const errors: any = {};

 
    if (!values.cellphoneNumber) {
        errors.cellphoneNumber = "שדה טלפון נייד הינו חובה";
    } else if (values.cellphoneNumber.length !== 7) {
        errors.cellphoneNumber = "הוזן מספר לא תקין";
    } else if (
        // check for every digit is a number
        values.cellphoneNumber
            .split("")
            .filter((digit: string) => parseInt(digit) >= 0 && parseInt(digit) <= 9)
            .length !== 7
    ) {
        errors.cellphoneNumber = "לא ניתן להזין תו שונה מספרה";
    }


    if (values.homePhoneNumber.length !== 0) {
        if (!values.homePhoneCode.length) {
            errors.homePhoneCode = "לא הוזנה קידומת לטלפון בבית";
        }
        if (values.homePhoneNumber.length !== 7  || getSumOfDigits(values.homePhoneNumber) < 14) {
            errors.homePhoneNumber = "הוזן מספר לא תקין";
        } else if (
            values.homePhoneNumber
                .split("")
                .filter((digit: string) => parseInt(digit) >= 0 && parseInt(digit) <= 9)
                .length !== 7
        ) {
            errors.homePhoneNumber = "לא ניתן להזין תו שונה מספרה";
        }
        
        if (
            (values?.homePhoneNumber?.length &&
            values.homePhoneCode === homePhoneCodes[0]) || getSumOfDigits(values.homePhoneCode) === 0 || cellphoneCodes.includes(values.homePhoneCode)
            ) {
                errors.homePhoneCode = "חסר קידומת";
            }
    }
        if (
            values.homePhoneCode.length !==1 &&
            values.homePhoneCode &&
            values.homePhoneCode !== homePhoneCodes[0] &&
            values.homePhoneNumber.length === 0
        ) {
            errors.homePhoneNumber = "שדה טלפון בבית הינו חובה";
        }


    if (!values.email) {
        errors.email = "שדה דואר אלקטרוני הינו חובה";
    } else if (values.email.length > 50) {
        errors.email = "הוזן דואר אלקטרוני לא תקין";
    } else if (!values.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        errors.email = "הוזן דואר אלקטרוני לא תקין";
    } else if (values.email[0] === ".") {
        errors.email = "הוזן דואר אלקטרוני לא תקין";
    }


    if (!values.userCity ||
        (values.userCity == 'לא נבחר ישוב' ||
            values.userCity == 'חסר קוד עיר' ||
            values.userCity == 'קוד עיר לא חוקי')) {
        errors.userCity = "שדה יישוב הינו חובה";
    }



    if (!(values.userAddress && values.homeAddressNumber)) {
        if (!values.userMailBox) {
            if (!values.userAddress) {
                errors.userAddress = "יש להזין רחוב ומספר בית או תא דואר";
            }
            if (!values.homeAddressNumber) {
                errors.homeAddressNumber = "יש להזין רחוב ומספר בית או תא דואר"
            }
            errors.userMailBox = "יש להזין רחוב ומספר בית או תא דואר";
        } else if (values.userMailBox.length > 5) {
            errors.userMailBox = "הוזן תא דואר לא תקין";
        } else if (
            values.userMailBox
                .split("")
                .filter((digit: string) => parseInt(digit) >= 0 && parseInt(digit) <= 9)
                .length !== values.userMailBox.length
        ) {
            errors.userMailBox = "הוזן תא דואר לא תקין";
        }

    }

    if (!values.userPostalCode) {
        errors.userPostalCode = "שדה מיקוד הינו חובה";
    }
    else if (values.userPostalCode.toString().length !== 7) {
        errors.userPostalCode = "הוזן מיקוד לא תקין";
    }
    else if (
        values.userPostalCode.toString()
            ?.split("")
            .filter((digit: string) => parseInt(digit) >= 0 && parseInt(digit) <= 9)
            .length !== 7
    ) {
        errors.userPostalCode = "לא ניתן להזין תו שונה מספרה";
    }

    if (!values.cellphoneCode) {
        errors.cellphoneCode = i18n.t("RegThirdStep.cellphonePrefixMust");
    }

    if (values.userAddress && !(hebrewRegex.test(values.userAddress))){

        errors.userAddress = "הוזן ערך לא תקין";
    }
    if (values.homeAddressNumber && (regExpAZ.test(values.homeAddressNumber) || values.homeAddressNumber.match(regExpAZ) || values.homeAddressNumber.length > 5 || values.homeAddressNumber.match(/[*|\:<>[\]{}`\\()!#%^_+=~;@&$]/))) {
        errors.homeAddressNumber = "הוזן ערך לא תקין";
    }

    // if (!values.homeAddressNumber) {
    //     errors.homeAddressNumber = "שדה מספר בית הינו חובה";
    // }


    return errors;
};

    const removeDuplicateCities = (cities: City[]) => {
        const citiesArr: any = [];

        if (cities?.length) {
            cities.forEach((city: any) => {
                if (!citiesArr.includes(city.cityDescription) &&
                    city.cityCode !== InvalidCityCode &&
                    city.cityCode !== MissingCityCode &&
                    city.cityCode !== Nosettlementchosen) {
                    city.cityDescription !== "אחר" &&
                        citiesArr.push(city.cityDescription);
                }
            });
        }
        return citiesArr;
    };

    useEffect(() => {
        async function init() {
            if (props.fromPersonalDetails) {
                // if the parent component is personal details, the user is online and
                // we have access to user state
                GetCities().then((cities)=>{
                    // const memberDetails = await GetMemberDetails();
                    setCitiesFullList(cities);
                    setCitiesList(removeDuplicateCities(cities));
                    setMemberData(props.memberDetails);
                    setLoading(false);
                });                
            } else {
                Promise.all([GetCities(), GetMemberDetails(), GetMemberFunds()]).then(
                    async (results) => {
                        setCitiesFullList(results[0]);
                        setCitiesList(removeDuplicateCities(results[0]));
                        setMemberData(results[1]);
                        setLoading(false);
                    }
                );
            }
        }

        init();
        // eslint-disable-next-line
    }, [props.memberDetails]); // check it on register

    const formik = useFormik({
        initialValues: {
            cellphoneCode:
                memberData?.cellPhone &&
                    (memberData?.cellPhone?.length === 10 ||
                        memberData?.cellPhone?.length === 11)
                    ? memberData.cellPhone.slice(0, 3)
                    : "",
            cellphoneNumber:
                memberData?.cellPhone &&
                    (memberData?.cellPhone?.length === 10 ||
                        memberData?.cellPhone?.length === 11)
                    ? getCellphoneNumber(memberData.cellPhone)
                    : "",
            homePhoneCode:
                memberData?.phone &&
                    (memberData?.phone?.length === 10 || memberData?.phone?.length === 9 || memberData?.phone?.length === 11) && 
                    getSumOfDigits(memberData?.phone.replace(/-/g, '')) > 0
                    ? memberData.phone.slice(0, 3)?.replace(/-/g, '')
                    : homePhoneCodes[0],
            homePhoneNumber:
                memberData?.phone &&
                    (memberData?.phone?.length === 10 || memberData?.phone?.length === 9 || memberData?.phone?.length === 11)
                    ? memberData.phone.split("-")[1] || memberData.phone.slice(3)
                    : "",
            email: memberData?.email ? memberData.email : "",
            userCity:
                memberData?.cityCode && citiesFullList?.length
                    ? getCityLabel(citiesFullList, memberData.cityCode)
                    : "",
            userAddress: memberData?.street ? memberData.street : "",
            homeAddressNumber: memberData?.number ? memberData.number : "",
            apartmentNumber: memberData?.apartmentNumber ? memberData.apartmentNumber : "",
            userMailBox: memberData?.postOfficeCode ? memberData.postOfficeCode : "",
            userPostalCode: memberData?.postCode ? memberData.postCode : "",
            deliveryOption:
                memberData?.emailAcceptAgreementCode
                    ? getDeliveryOptionLabel(memberData.emailAcceptAgreementCode)
                    : t("RegThirdStep.deliveryOption2"),
            isChecked: memberData?.digitalDepositInfoInd ? true : false,
        },
        validate,
        enableReinitialize: true,
        onSubmit: async (values: RegThirdStepValues) => {
            setSubmitLoading(true);
            const userUpdatedData = getUserUpdatedData(values);
            if (props.fromPersonalDetails && isPhoneAndEmailUpdated(values)) {
                // handle verify privacy questions case when user changes cellphone number and email
                handleVerifyPrivacyQuestions(userUpdatedData);
            } else if (
                props.fromPersonalDetails &&
                !isUserDataChanged(userUpdatedData)
            ) {
                openErrorPopup();
            } else {
                const updateMemberStatus = await UpdateMemberDetails(userUpdatedData);
                if (updateMemberDetailsUtil.isSuccess(updateMemberStatus)) {
                    if (props.activeStep && props.setActiveStep) {
                        // register flow, if success continue to next step.
                        props.setActiveStep(props.activeStep + 1);
                    } else if (props.fromPersonalDetails) {
                        // personal details flow, open success popup on-success, and track
                        // the latest member data for user data changed check.
                        openSuccessPopUp();
                        setMemberData(Object.assign(memberData, userUpdatedData));
                    }
                } else if (
                    // handle verify privacy questions returns from API
                    updateMemberDetailsUtil.isNotVerifyAnswersError(updateMemberStatus)
                ) {
                    handleVerifyPrivacyQuestions(userUpdatedData);
                } else {
                    if (updateMemberStatus === 'Max_Users_With_Same_CellPhone') {
                        setupdateErrorPhone(true)
                        setUpdateError(false);
                    } else if (updateMemberStatus === 'Max_Users_With_Same_Email') {
                        setupdateErrorEmail(true)
                        setUpdateError(false);
                    } else {
                        setupdateErrorPhone(false)
                        setupdateErrorEmail(false)
                        setUpdateError(true);
                    }
                }
            }
            setSubmitLoading(false);
        },
    });

    const isUserDataChanged = (userUpdatedData: any) => {
        for (const key in userUpdatedData) {
            if (userUpdatedData[key] !== memberData[key]) return true;
        }
        return false;
    };

    const handleVerifyPrivacyQuestions = (userUpdatedData: any) => {
        localStorage.setItem(
            "updateMemberDetailsBody",
            JSON.stringify(userUpdatedData)
        );
        history.push("/privacy-questions");
    };

    const isPhoneAndEmailUpdated = (values: RegThirdStepValues) =>
        memberData?.email !== values.email && isPhoneUpdated(values);

    const isPhoneUpdated = (values: RegThirdStepValues) => {
        if (memberData?.cellPhone?.includes("-")) {
            return (
                memberData.cellPhone !==
                `${values.cellphoneCode}-${values.cellphoneNumber}`
            );
        }
        return (
            memberData?.cellPhone !==
            `${values.cellphoneCode}${values.cellphoneNumber}`
        );
    };


    const getUserUpdatedData = (values: RegThirdStepValues) => {

        return {
            cityCode: getCityCode(citiesFullList, values.userCity),
            street: values.userAddress,
            number: values.homeAddressNumber,
            apartmentNumber: `${values.apartmentNumber}`,
            postCode: `${values.userPostalCode}`,
            postOfficeCode: values.userMailBox.length ? values.userMailBox : null,
            phone: values.homePhoneNumber && `${values.homePhoneCode}-${values.homePhoneNumber}`,
            cellPhone: `${values.cellphoneCode}-${values.cellphoneNumber}`,
            email: values.email,
            emailAcceptAgreementCode: getDeliveryOptionCode(values.deliveryOption),
            digitalDepositInfoInd: values.isChecked ? 1 : 0,
        };
    };

    const openSuccessPopUp = () => {
        updateError && setUpdateError(false);
        dispatch(setModalState(true));
        dispatch(
            setModalChild(
                <RequestAcceptedPopup
                    size="m"
                    center={true}
                    mainLabel={t("general.complete")}
                    secondLabel={t("general.dataUpdated")}
                />
            )
        );
    };

    const openErrorPopup = () => {
        dispatch(setModalState(true));
        dispatch(
            setModalChild(
                <ErrorPopup
                    size="m"
                    label={t("personalDetails.dataNotChangedError")}
                    center={true}
                    subLabel={t("personalDetails.dataNotChangedSub")}
                />
            )
        );
    };

    const openPostalWebsite = () => {
        const postalWebsiteUrl = "https://israelpost.co.il/שירותים/איתור-מיקוד";
        window.open(postalWebsiteUrl);
    };

    const InputFocus = useInputFocus(formik.errors, formik.submitCount, clickbtnsub);
    useEffect(() => {
        if (InputFocus) {
            setClickbtnsub(false);
        }
    }, [InputFocus, clickbtnsub]);


    return loading ? (
        <CircleLoading />
    ) : (
        <>
            <div className="third-user-details-wrapper">
                <div className="third-user-detail">
                    <span className="third-user-detail-title">
                        {t("RegThirdStep.fullName")}
                    </span>
                    <span className="third-user-detail-label">{`${memberData?.firstName || ""
                        } ${memberData?.lastName || ""}`.slice(0, 19)}</span>
                </div>
                <div className="third-user-detail">
                    <span className="third-user-detail-title">
                        {t("RegThirdStep.id")}
                    </span>
                    <span className="third-user-detail-label">
                        {getUserIdWithZeros(JSON.stringify(memberData?.memberId))}
                    </span>
                </div>
                <div className="third-user-detail">
                    <span className="third-user-detail-title">
                        {t("RegThirdStep.dateOfBirth")}
                    </span>
                    <span className="third-user-detail-label">
                        {memberData?.birthDate?.length &&
                            getFormatDate(memberData.birthDate)}
                    </span>
                </div>
                <div className="third-user-detail">
                    <span className="third-user-detail-title">
                        {t("RegThirdStep.gender")}
                    </span>
                    <span className="third-user-detail-label">
                        {typeof memberData?.gender === "number" &&
                            getGenderLabel(memberData.gender)}
                    </span>
                </div>
                <div className="third-user-detail">
                    <span className="third-user-detail-title">
                        {t("RegThirdStep.relationStatus")}
                    </span>
                    <span className="third-user-detail-label">
                        {typeof memberData?.meritalStatus === "number" &&
                            getMeritalStatusLabel(memberData.meritalStatus)}
                    </span>
                </div>
            </div>
            {props.fromPersonalDetails ? (
                <div className="personal-details-title">
                    <h2>{t("personalDetails.details")}</h2>
                </div>
            ) : null}
            <form onSubmit={formik.handleSubmit}>
                <div className="d-flex align-items-end justify-content-space-between first-row">
                    <div
                        className="d-flex align-items-end w-mobile-100"
                        style={{ width: props.fromPersonalDetails ? "45%" : "" }}
                    >
                        <TextField
                            inputProps={{
                                'aria-required': "true",
                                maxLength: 7
                            }}
                            aria-describedby="cellphoneNumber"
                            label={`${t("RegThirdStep.cellphone")}*`}
                            id="cellphoneNumber"
                            name="cellphoneNumber"
                            size="small"
                            variant="standard"
                            value={formik.values.cellphoneNumber}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            aria-required="true"
                            helperText={formik.errors.cellphoneNumber && formik.errors.cellphoneNumber}
                            autoComplete={"off"}
                            className={`reg-input-focus ${formik.touched.cellphoneNumber && formik.errors.cellphoneNumber
                                ? "reg-input-error"
                                : ""
                                }`}

                            sx={{
                                marginTop: "3px",
                                width: props.fromPersonalDetails ? "100%" : 102,
                                "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#000000",
                                },
                            }}

                        />
                        <FormControl
                            variant="standard"
                            sx={{
                                minWidth: props.fromPersonalDetails ? 100 : 85,
                                marginRight: "16px",
                            }}
                            className={`reg-input-focus ${formik.touched.cellphoneCode && formik.errors.cellphoneCode
                                ? "reg-input-error"
                                : ""
                                }`}
                        >
                            <InputLabel id="demo-simple-select-label" htmlFor="cellphoneCode" aria-hidden="true" >
                                {t("RegThirdStep.phoneCode")}*
                            </InputLabel>
                            <NativeSelect
                                inputProps={{
                                    'aria-required': "true"

                                }}
                                aria-required="true"
                                aria-describedby="cellphoneCode"
                                id="cellphoneCode"
                                name="cellphoneCode"
                                aria-label={t("RegThirdStep.cellphoneCode")}
                                value={formik.values.cellphoneCode}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                IconComponent={KeyboardArrowDownIcon}

                                sx={{
                                    marginTop: '0px !important',
                                    WebkitTextFillColor: "#000000",

                                }}
                            >
                                {cellphoneCodes.map((cellphoneCode: string) => (
                                    <option key={cellphoneCode} value={cellphoneCode}>
                                        {cellphoneCode}
                                    </option >
                                ))}
                            </NativeSelect >
                        </FormControl>
                    </div>
                    <div
                        className="d-flex align-items-end w-mobile-100"
                        style={{ width: props.fromPersonalDetails ? "45%" : "" }}
                    >
                        <TextField

                            aria-describedby="homePhoneNumber"
                            label={formik.values.homePhoneCode.length !==1 &&
                                formik.values.homePhoneCode &&
                                formik.values.homePhoneCode !== homePhoneCodes[0] &&
                                formik.values.homePhoneNumber.length === 0 ? t("RegThirdStep.homePhone") :  t("RegThirdStep.homePhone1")}
                            id="homePhoneNumber"
                            name="homePhoneNumber"
                            size="small"
                            variant="standard"
                            value={formik.values.homePhoneNumber}
                            helperText={formik.errors.homePhoneNumber && formik.errors.homePhoneNumber}
                            onBlur={formik.handleBlur}
                            autoComplete={"off"}
                            onChange={formik.handleChange}
                            className={`reg-input-focus ${formik.touched.homePhoneNumber && formik.errors.homePhoneNumber
                                ? "reg-input-error"
                                : ""
                                }`}

                            sx={{
                                marginTop: "3px",
                                width: props.fromPersonalDetails ? "100%" : 102,
                                "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#000000",
                                },
                            }}
                            //InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 7 }}

                        />
                        <FormControl
                            variant="standard"
                            sx={{
                                minWidth: props.fromPersonalDetails ? 100 : 85,
                                marginRight: "16px",
                            }}
                            className={`reg-input-focus ${formik.touched.homePhoneCode && formik.errors.homePhoneCode
                                ? "reg-input-error"
                                : ""
                                }`}
                        >
                            <InputLabel id="demo-simple-select-label">
                                {t("RegThirdStep.phoneCode")}
                            </InputLabel>

                            <NativeSelect
                                inputProps={{ "aria-required": "true", "aria-label": t("RegThirdStep.cellphoneCode") }}
                                aria-describedby="homePhoneCode"
                                id="homePhoneCode"
                                name="homePhoneCode"
                                value={formik.values.homePhoneCode}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                IconComponent={KeyboardArrowDownIcon}
                                sx={{

                                    WebkitTextFillColor: "#000000",
                                    marginTop: '0px !important'

                                }}
                            >
                                {homePhoneCodes.map((homePhoneCode: string) => (
                                    <option key={homePhoneCode} value={homePhoneCode}>
                                        {homePhoneCode}
                                    </option>
                                ))}
                            </NativeSelect>
                            <FormHelperText>{formik.errors.homePhoneCode && formik.errors.homePhoneCode}</FormHelperText>
                        </FormControl>
                    </div>
                </div>
                <div className="d-flex align-items-start reg-input-mt">
                    <TextField
                        inputProps={{
                            'aria-required': "true"

                        }}
                        aria-required="true"
                        aria-describedby="email"
                        label={`${t("RegThirdStep.email")}*`}
                        id="email"
                        name="email"
                        fullWidth
                        variant="standard"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        helperText={formik.errors.email && formik.errors.email}
                        autoComplete={"off"}
                        className={`reg-input-focus ${formik.touched.email && formik.errors.email
                            ? "reg-input-error"
                            : ""
                            }`}

                        sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                            },
                        }}
                    />
                </div>
                <div className="d-flex align-items-start reg-input-mt">
                    <Autocomplete
                        aria-required="true"
                        aria-describedby="userCity"
                        disablePortal
                        id="userCity"
                        options={citiesList}
                        value={(formik?.values?.userCity !== 'לא נבחר ישוב' && formik?.values?.userCity !== 'חסר קוד עיר' && formik?.values?.userCity !== 'קוד עיר לא חוקי') && formik?.values?.userCity !== null ? formik?.values?.userCity : null}
                        onChange={(e, value) => {
                            formik.setFieldValue("userCity", value)
                        }}
                        fullWidth
                        noOptionsText={t("RegThirdStep.noOptions")}
                        popupIcon={<SearchIcon />}
                        forcePopupIcon
                        renderInput={(params) => (
                            /* @ts-ignore:next-line */
                            <TextField
                                {...params}
                                inputProps={{
                                    ...params.inputProps,
                                    'aria-required': "true"

                                }}
                                aria-required="true"
                                label={`${t("RegThirdStep.city")}*`}
                                aria-describedby="userCity"
                                name="userCity"
                                fullWidth
                                variant="standard"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                helperText={formik.errors.userCity && formik.errors.userCity}
                                className={`reg-input-focus ${formik.touched.userCity && formik.errors.userCity
                                    ? "reg-input-error"
                                    : ""
                                    }`}

                                sx={{
                                    "& .MuiInputBase-input.Mui-disabled": {
                                        WebkitTextFillColor: "#000000",
                                    },
                                }}
                            />
                        )}
                    />
                </div>
                <div className="d-flex align-items-start reg-input-mt">
                    <TextField
                        aria-required="true"
                        aria-describedby="userAddress"
                        label={`${t("RegThirdStep.street")}*`}
                        id="userAddress"
                        name="userAddress"
                        fullWidth
                        inputProps={{
                            'aria-required': "true",
                            maxLength: 29

                        }}
                        variant="standard"
                        value={formik.values.userAddress}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        helperText={formik.errors.userAddress && formik.errors.userAddress}
                        autoComplete={"off"}
                        className={`reg-input-focus ${formik.touched.userAddress && formik.errors.userAddress
                            ? "reg-input-error"
                            : ""
                            }`}

                        sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#000000",
                            },
                        }}
                    />
                </div>
                <div
                    className="d-flex align-items-start justify-content-space-between reg-input-mt small-field-mobile">
                    <div
                        className="d-flex align-items-start w-215"
                        style={{ width: props.fromPersonalDetails ? "45%" : "" }}
                    >
                        <TextField
                            inputProps={{
                                'aria-required': "true",
                                maxLength: 5

                            }}
                            aria-required="true"
                            aria-describedby="homeAddressNumber"
                            label={`${t("RegThirdStep.homeNumber")}*`}
                            id="homeAddressNumber"
                            name="homeAddressNumber"
                            fullWidth
                            variant="standard"
                            value={formik.values.homeAddressNumber}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={formik.errors.homeAddressNumber && formik.errors.homeAddressNumber}
                            autoComplete={"off"}
                            className={`reg-input-focus ${formik.touched.homeAddressNumber &&
                                formik.errors.homeAddressNumber
                                ? "reg-input-error"
                                : ""
                                }`}

                            sx={{
                                "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#000000",
                                },
                            }}
                        />
                    </div>                    
                    <div
                        className="d-flex align-items-start w-215 flex-end-mobile"
                        style={{ width: props.fromPersonalDetails ? "45%" : "" }}
                    >
                        <TextField                           
                            aria-describedby="userMailBox"
                            label={t("RegThirdStep.mailBox")}
                            id="userMailBox"
                            name="userMailBox"
                            fullWidth
                            variant="standard"
                            value={formik.values.userMailBox}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={formik.errors.userMailBox && formik.errors.userMailBox}
                            autoComplete={"off"}
                            className={`reg-input-focus ${formik.touched.userMailBox && formik.errors.userMailBox
                                ? "reg-input-error"
                                : ""
                                }`}
                            inputProps={{
                                maxLength: 5
                            }}

                            sx={{
                                "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#000000",
                                },
                            }}
                        />
                    </div>
                </div>
                {/* <div
                    className="d-flex align-items-start justify-content-space-between reg-input-mt small-field-mobile">
                    <div
                        className="d-flex align-items-start w-215"
                        style={{ width: props.fromPersonalDetails ? "45%" : "" }}
                    >
                        <TextField                       
                            inputProps={{
                                maxLength: 4                                
                            }}
                            onInput={(e) => { (e.target as HTMLInputElement).value = Math.max(0, parseInt((e.target as HTMLInputElement).value)).toString().slice(0, 4) }}
                            aria-describedby="apartmentNumber"
                            label={`${t("RegThirdStep.apartmentNumber")}`}
                            id="apartmentNumber"
                            name="apartmentNumber"
                            fullWidth
                            variant="standard"
                            type="number"
                            value={formik.values.apartmentNumber}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={formik.errors.apartmentNumber && formik.errors.apartmentNumber}
                            autoComplete={"off"}
                            className={`reg-input-focus ${formik.touched.apartmentNumber &&
                                formik.errors.apartmentNumber
                                ? "reg-input-error"
                                : ""
                                }`}
                            sx={{
                                "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#000000",
                                },
                            }}
                        />
                    </div>                    
                </div> */}
                <div
                    className={`d-flex align-items-start w-215  ${props.fromPersonalDetails ? "" : "justify-content-space-between "
                        }reg-input-mt space-between-mobile`}
                >
                    <div
                        className="d-flex align-items-start"
                        style={{ width: props.fromPersonalDetails ? "45%" : "" }}
                    >
                        <TextField
                            aria-required="true"
                            aria-describedby="userPostalCode"
                            label={`${t("RegThirdStep.postalCode")}*`}
                            id="userPostalCode"
                            name="userPostalCode"
                            fullWidth
                            variant="standard"
                            value={formik.values.userPostalCode}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            helperText={formik.errors.userPostalCode && formik.errors.userPostalCode}
                            type="number"
                            inputProps={{
                                'aria-required': "true",
                                maxLength: 7
                            }}
                            onInput={(e) => { (e.target as HTMLInputElement).value = Math.max(0, parseInt((e.target as HTMLInputElement).value)).toString().slice(0, 7) }}
                            autoComplete={"off"}
                            className={`reg-input-focus ${formik.touched.userPostalCode && formik.errors.userPostalCode
                                ? "reg-input-error"
                                : ""
                                }`}

                            sx={{
                                "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#000000",
                                },
                            }}
                        />
                    </div>
                    <a style={{ textDecorationLine: "none" }} className="third-step-postal-label"
                        role="link"
                        target="_blank" 
                        rel="noopener noreferrer"
                        href="https://israelpost.co.il/שירותים/איתור-מיקוד"
                        onKeyPress={(event) => isEnterPress(event) && openPostalWebsite()}

                    >
                        {t("RegThirdStep.findPostal")}
                        <img src={arrowleft} alt="arrowleft" />
                    </a>
                </div>
                {props.fromPersonalDetails ? (
                    <div className="d-flex align-items-start reg-input-mt block-mobile">
                        <div
                            className="d-flex align-items-start w-mobile-100"
                            style={{ width: props.fromPersonalDetails ? "45%" : "" }}
                        >
                            <FormControl
                                variant="standard"
                                fullWidth
                                className="reg-input-focus"
                            >
                                <InputLabel htmlFor="deliveryOption" shrink>
                                    {t("RegThirdStep.deliveryKind")}*
                                </InputLabel>
                                <Select
                                    inputProps={{
                                        'aria-required': "true"
                                    }}
                                    aria-required="true"
                                    aria-describedby="deliveryOption"
                                    id="deliveryOption"
                                    name="deliveryOption"
                                    value={formik.values.deliveryOption}
                                    onChange={formik.handleChange}
                                    IconComponent={KeyboardArrowDownIcon}
                                    defaultValue={formik.values.deliveryOption}

                                    //label={t("RegThirdStep.deliveryKind")}
                                    sx={{
                                        "& .MuiInputBase-input.Mui-disabled": {
                                            WebkitTextFillColor: "#000000",
                                        },
                                    }}
                                >
                                    {deliveryOptions.map((deliveryOption: string) => (
                                        <MenuItem key={deliveryOption} value={deliveryOption} style={{display: deliveryOption === t("RegThirdStep.deliveryOption1") ||  deliveryOption === t("RegThirdStep.deliveryOption5") ? "none" : ""}}>
                                            {deliveryOption}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        <div
                            className="d-flex align-items-start m-0-mobile m-top-mobile"
                            style={{ marginRight: props.fromPersonalDetails ? 100 : "" }}
                        >
                            <FormGroup sx={{ marginRight: "-1rem" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            sx={{
                                                "&.Mui-checked": {
                                                    color: "#0250C1",
                                                },
                                                "&.Mui-focusVisible": {
                                                    outline: "3px solid #10059f",
                                                    borderRadius: "0px"
                                                },
                                            padding: "3px 0px",
                                            margin: "0px 10px",
                                                color: "#aaa7a7",
                                            }}
                                            id="isChecked"
                                            name="isChecked"
                                            value={formik.values.isChecked}
                                            onChange={formik.handleChange}
                                            checked={formik.values.isChecked}
                                            
                                        />
                                    }
                                    label={
                                        <span className="register-checkbox-label">
                                            {t("RegThirdStep.checkboxLabel")}*
                                        </span>
                                    }
                                />
                            </FormGroup>
                            <div style={{ marginRight: 16 }}>
                                <HelpCircleIcon title={t("arialabel.btntabel")} label={t("Register.depositExplain")} />
                            </div>
                        </div>

                    </div>
                ) : (
                    <>
                        <div className="d-flex align-items-start reg-input-mt">
                            <FormControl
                                variant="standard"
                                fullWidth
                                className="reg-input-focus"
                            >
                                <InputLabel htmlFor="deliveryOption" shrink>
                                    {t("RegThirdStep.deliveryKind")}*
                                </InputLabel>

                            </FormControl>
                        </div>

                        <div
                            className="d-flex align-items-start m-0-mobile m-top-mobile"
                            style={{ marginRight: props.fromPersonalDetails ? 100 : "" }}
                        >
                            <FormGroup sx={{ marginRight: "-1rem" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            sx={{
                                                "&.Mui-checked": {
                                                    color: "#0250C1",
                                                },
                                                "&.Mui-focusVisible": {
                                                    outline: "3px solid #10059f",
                                                    borderRadius: "0px"
                                                },
                                            padding: "3px 0px",
                                            margin: "0px 10px",
                                            color: "#aaa7a7",
                                            }}
                                            id="isChecked"
                                            name="isChecked"
                                            value={formik.values.isChecked}
                                            onChange={formik.handleChange}
                                            checked={formik.values.isChecked}
                                        />
                                    }
                                    label={
                                        <span className="register-checkbox-label">
                                            {t("RegThirdStep.checkboxLabel")}*
                                        </span>
                                    }
                                />
                            </FormGroup>
                            <div style={{ marginRight: 16 }}>
                                <HelpCircleIcon title={t("arialabel.btntabel")} label={t("Register.depositExplain")} />
                            </div>
                        </div>

                    </>
                )}

                {(Object.keys(formik?.errors).length && formik.submitCount) ||
                    updateError ? (
                    <div style={{ marginTop: "10px" }}>
                        <RenderInputError
                            errorLabel={
                                updateError
                                    ? t("RegThirdStep.updateError")
                                    : t("RegThirdStep.inputError")
                            }
                        />
                    </div>
                ) : updateErrorPhone ?
                    <div style={{ marginTop: "10px" }}>
                        <RenderInputError
                            errorLabel={
                                t("RegThirdStep.updateErrorPhone")
                            }
                        />
                    </div>
                    :
                    updateErrorEmail ?
                        <div style={{ marginTop: "10px" }}>
                            <RenderInputError
                                errorLabel={
                                    t("RegThirdStep.updateErrorEmail")
                                }
                            />
                        </div> : null
                }


                <button
                    type="submit"
                    className="third-step-button"
                    disabled={submitLoading}
                    onClick={() => setClickbtnsub(true)}
                >

                    <span>{`${submitLoading
                        ? t("general.loading")
                        : t("RegThirdStep.saveChanges")
                        }`}</span>

                </button>

            </form>
        </>
    );
};

export default RegThirdStep;
